export const environment = {
  rememberMeKey: 'MW_RM_K_D',
  base_url:'https://mindbaseuserapi.appgrowthcompany.com/', // webDev
  core_url: '',
  image_url: 'https://mindbaseuserapi.appgrowthcompany.com/media/uploadFile',
  storageKey: 'MW_ST_K_D',
  socket_url: 'https://mindbasesocketapi.appgrowthcompany.com/',
  stripePublicKey: 'pk_test_51Qpp54E9dCHbiXJV6Okor1RpLgwCLKDTvIIOq7SFdVfU7Q1UyuoVFactBrmrdqCe1ZYcx4gh53KIZjJDh4522teq00jWleYgRa',
  gClientId: '443733978916-cqcj9gsr1p92dr991s6khp8p6alslcfn.apps.googleusercontent.com',
  gScopes: 'https://www.googleapis.com/auth/calendar',
  gDiscoverDoc: 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
  facebookAppId: '',
  appleAppId: 'com.mindbase.apple',
  langKey: 'lang',
  firebaseConfig: {
    apiKey: 'AIzaSyA74yJXmt34C2E_yyTQOgwMlH12O90rS9w',
    authDomain: 'prepbase-76b91.firebaseapp.com',
    projectId: 'prepbase-76b91',
    storageBucket: 'prepbase-76b91.firebasestorage.app',
    messagingSenderId: '181364161362',
    appId: '1:181364161362:web:55962752a843c55a81d88b',
    measurementId: 'G-GTENSLC3WN',
    vapidKey: 'BAeAjs2pkYIY9TwQfEw6394Sf1-drYjtBpqmXfxj38au1sEkS-TWxUQ35lgn2AI5XlMBshcUjY6snJIAyR1mnCw'
  }
};
